export const OPEN_SNACKBAR = 'OPEN_SNACKBAR';
export const CLOSE = 'CLOSE'
export const OPEN_DIALOG401 = 'OPEN_DIALOG401';
export const OPEN_CONFIRMATION = 'OPEN_CONFIRMATION';
export const OPEN_TEXTAREA = 'OPEN_TEXTAREA';

export const snackbar = (payload) => dispatch =>
  dispatch({
    type: OPEN_SNACKBAR,
    payload
  });

export const confirmationDialog = (payload) => dispatch =>
  dispatch({
    type: OPEN_CONFIRMATION,
    payload
  })

export const dialog401 = (payload) => dispatch =>
  dispatch({
    type: OPEN_DIALOG401,
    payload
  });

export const closeAlert = () => dispatch => {
  dispatch({
    type: CLOSE,
  });
}

export const textareaDialog = (payload) => dispatch =>
  dispatch({
    type: OPEN_TEXTAREA,
    payload
  })
